export default __webpack_public_path__ + "static/media/884.df45098c.png";